"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDialogSlots = exports.default = exports.Dialog = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _DialogBase = require("../DialogBase");
var _utils = require("../utils");
var _dialogClasses = require("./dialogClasses");
var _jsxRuntime = require("react/jsx-runtime");
var getDialogSlots = function(ownerState) {
    var size = ownerState.size;
    return {
        root: [
            'root',
            "size".concat((0, _utils.capitalize)(size))
        ],
        backButton: [
            'backButton'
        ],
        closeButton: [
            'closeButton'
        ],
        dialogGrid: [
            'dialogGrid'
        ],
        content: [
            'content'
        ],
        header: [
            'header'
        ]
    };
};
exports.getDialogSlots = getDialogSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getDialogSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _dialogClasses.getDialogUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var DialogRoot = (0, _material.styled)('div', {
    name: 'MuiOriDialog',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            styles["size".concat((0, _utils.capitalize)(ownerState.size))]
        ];
    },
    shouldForwardProp: function(prop) {
        return (0, _utils.rootShouldForwardProp)(prop);
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread(_define_property({
        position: 'fixed',
        zIndex: theme.zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 0
    }, theme.breakpoints.only('xs'), {
        alignItems: 'flex-end'
    }), ownerState.keepMounted && !ownerState.open && {
        visibility: 'hidden'
    });
});
var DialogBackdrop = (0, _material.styled)(_material.Backdrop, {
    name: 'MuiOriDialog',
    slot: 'Backdrop',
    overridesResolver: function(_, styles) {
        return [
            styles.backdrop
        ];
    }
})({
    zIndex: -1
});
var DialogGrid = (0, _material.styled)(_material.Paper, {
    name: 'MuiOriDialog',
    slot: 'DialogGrid',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.dialogGrid
        ];
    },
    shouldForwardProp: function(prop) {
        return (0, _utils.shouldForwardProp)(prop);
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread_props(_object_spread({
        display: 'grid',
        gridTemplateAreas: '\n    ". header ."\n    "content content content"\n  ',
        gridTemplateColumns: '1fr auto 1fr',
        gridTemplateRows: 'auto 1fr',
        justifyItems: 'stretch',
        position: 'relative',
        minWidth: 320,
        maxWidth: ownerState.maxWidth
    }, ownerState.fullWidth && {
        width: "calc(100% - ".concat(_DialogBase.DEFAULT_DIALOG_PADDING, ")")
    }), _define_property({
        minHeight: 100,
        maxHeight: "calc(100% - ".concat(theme.spacing(32), ")"),
        outline: 0,
        overflow: 'hidden',
        padding: 0
    }, theme.breakpoints.only('xs'), {
        boxSizing: 'border-box',
        minWidth: '100vw',
        maxWidth: '100vw',
        width: '100vw',
        maxHeight: "calc(100% - ".concat(theme.spacing(12), ")"),
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    }));
});
var Header = (0, _material.styled)('div', {
    name: 'MuiOriDialog',
    slot: 'Header',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.header
        ];
    },
    shouldForwardProp: function(prop) {
        return (0, _utils.shouldForwardProp)(prop);
    }
})(function(param) {
    var theme = param.theme;
    return _define_property({
        gridArea: 'header',
        padding: theme.spacing(8, 6, 0, 6)
    }, theme.breakpoints.only('xs'), {
        padding: theme.spacing(7, 3, 3, 3)
    });
});
var Content = (0, _material.styled)(_material.ScopedCssBaseline, {
    name: 'MuiOriDialog',
    slot: 'Content',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.content
        ];
    },
    shouldForwardProp: function(prop) {
        return (0, _utils.shouldForwardProp)(prop);
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        gridArea: 'content',
        background: 'transparent',
        height: '100%',
        overflowY: 'auto',
        padding: 0
    }, ownerState.size === 'small' && {
        overflow: 'auto'
    }, ownerState.size === 'medium' && _define_property({
        scrollbarGutter: 'stable',
        padding: theme.spacing(0, 4, 6, 6)
    }, theme.breakpoints.only('xs'), {
        padding: theme.spacing(0, 3, 6, 3)
    }), ownerState.size === 'medium' && ownerState.header === undefined && _define_property({
        scrollbarGutter: 'stable',
        padding: theme.spacing(8, 4, 6, 6)
    }, theme.breakpoints.only('xs'), {
        padding: theme.spacing(7, 3, 6, 3)
    }));
});
var Dialog = exports.Dialog = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriDialog'
    });
    var ariaDescribedby = props.ariaDescribedby, ariaLabelledby = props.ariaLabelledby, _props_ariaModal = props.ariaModal, ariaModal = _props_ariaModal === void 0 ? true : _props_ariaModal, _ = props.backButton, _props_backButtonAriaLabel = props.backButtonAriaLabel, backButtonAriaLabel = _props_backButtonAriaLabel === void 0 ? 'back' : _props_backButtonAriaLabel, _props_backButtonProps = props.backButtonProps, backButtonProps = _props_backButtonProps === void 0 ? {
        variant: 'outlined',
        color: 'secondary',
        size: 'small'
    } : _props_backButtonProps, _props_children = props.children, children = _props_children === void 0 ? null : _props_children, className = props.className, _props_closeAfterTransition = props.closeAfterTransition, closeAfterTransition = _props_closeAfterTransition === void 0 ? true : _props_closeAfterTransition, _props_closeButtonAriaLabel = props.closeButtonAriaLabel, closeButtonAriaLabel = _props_closeButtonAriaLabel === void 0 ? 'close' : _props_closeButtonAriaLabel, _props_closeButtonProps = props.closeButtonProps, closeButtonProps = _props_closeButtonProps === void 0 ? {
        variant: 'outlined',
        color: 'secondary',
        size: 'small'
    } : _props_closeButtonProps, _props_disableAutoFocus = props.disableAutoFocus, disableAutoFocus = _props_disableAutoFocus === void 0 ? false : _props_disableAutoFocus, _props_disableEnforceFocus = props.disableEnforceFocus, disableEnforceFocus = _props_disableEnforceFocus === void 0 ? false : _props_disableEnforceFocus, _props_disableEscapeKeyDown = props.disableEscapeKeyDown, disableEscapeKeyDown = _props_disableEscapeKeyDown === void 0 ? false : _props_disableEscapeKeyDown, _props_disablePortal = props.disablePortal, disablePortal = _props_disablePortal === void 0 ? true : _props_disablePortal, _props_disableRestoreFocus = props.disableRestoreFocus, disableRestoreFocus = _props_disableRestoreFocus === void 0 ? false : _props_disableRestoreFocus, _props_disableScrollLock = props.disableScrollLock, disableScrollLock = _props_disableScrollLock === void 0 ? false : _props_disableScrollLock, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_maxWidth = props.maxWidth, maxWidth = _props_maxWidth === void 0 ? '60vw' : _props_maxWidth, header = props.header, _props_hideBackdrop = props.hideBackdrop, hideBackdrop = _props_hideBackdrop === void 0 ? false : _props_hideBackdrop, hideCloseButton = props.hideCloseButton, _props_keepMounted = props.keepMounted, keepMounted = _props_keepMounted === void 0 ? false : _props_keepMounted, onBack = props.onBack, open = props.open, showBackButton = props.showBackButton, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, transitionProps = props.transitionProps, other = _object_without_properties(props, [
        "ariaDescribedby",
        "ariaLabelledby",
        "ariaModal",
        "backButton",
        "backButtonAriaLabel",
        "backButtonProps",
        "children",
        "className",
        "closeAfterTransition",
        "closeButtonAriaLabel",
        "closeButtonProps",
        "disableAutoFocus",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "fullWidth",
        "maxWidth",
        "header",
        "hideBackdrop",
        "hideCloseButton",
        "keepMounted",
        "onBack",
        "open",
        "showBackButton",
        "size",
        "transitionProps"
    ]);
    var onClose = other.onClose;
    var commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    var maxWidthCalculated = (0, _react.useMemo)(function() {
        return (0, _DialogBase.calculateMaxWidth)(maxWidth);
    }, [
        maxWidth
    ]);
    var ownerState = (0, _react.useMemo)(function() {
        return _object_spread_props(_object_spread({}, props), {
            size: size,
            maxWidth: maxWidthCalculated,
            fullWidth: fullWidth
        });
    }, [
        fullWidth,
        maxWidthCalculated,
        props,
        size
    ]);
    var classes = useUtilityClasses(ownerState);
    var handleClose = (0, _react.useCallback)(function(event) {
        onClose === null || onClose === void 0 ? void 0 : onClose(event !== null && event !== void 0 ? event : {}, 'escapeKeyDown');
    }, [
        onClose
    ]);
    var handleBackClick = (0, _react.useCallback)(function() {
        onBack === null || onBack === void 0 ? void 0 : onBack();
    }, [
        onBack
    ]);
    var _props_backButton = props.backButton, backButton = _props_backButton === void 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DialogBase.BackButton, _object_spread_props(_object_spread({}, backButtonProps), {
        className: classes.backButton,
        ariaLabel: backButtonAriaLabel,
        handleClick: handleBackClick
    })) : _props_backButton;
    var headerComponent = (0, _react.useMemo)(function() {
        if (typeof header === 'undefined' || header === null || header === '') {
            return null;
        }
        if (typeof header === 'string') {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                ownerState: ownerState,
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.Typography, {
                    gutterBottom: true,
                    variant: "h4",
                    align: "center",
                    children: header
                })
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            ownerState: ownerState,
            className: classes.header,
            children: header
        });
    }, [
        classes.header,
        header,
        ownerState
    ]);
    var showChildren = (0, _react.useMemo)(function() {
        if (typeof children === 'undefined' || children === null) {
            return false;
        }
        return true;
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_base.Modal, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        slots: {
            root: DialogRoot,
            backdrop: DialogBackdrop
        },
        slotProps: {
            root: function() {
                return {
                    ownerState: ownerState
                };
            }
        },
        open: open,
        className: (0, _clsx.default)(classes.root, className)
    }, other), {
        ref: ref
    }), commonProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DialogBase.Transition, _object_spread_props(_object_spread({}, transitionProps), {
            in: open,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DialogGrid, {
                ownerState: ownerState,
                className: classes.dialogGrid,
                role: "dialog",
                "aria-describedby": ariaDescribedby,
                "aria-labelledby": ariaLabelledby,
                "aria-modal": ariaModal,
                children: [
                    showBackButton ? backButton : null,
                    !hideCloseButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DialogBase.CloseButton, _object_spread_props(_object_spread({}, closeButtonProps), {
                        className: classes.closeButton,
                        ariaLabel: closeButtonAriaLabel,
                        handleClick: handleClose
                    })),
                    headerComponent,
                    showChildren ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Content, {
                        ownerState: ownerState,
                        className: classes.content,
                        children: children
                    }) : null
                ]
            })
        }))
    }));
});
var _default = exports.default = Dialog; //# sourceMappingURL=Dialog.js.map
